// extracted by mini-css-extract-plugin
export var sliderRange = "_os-2";
export var sliderRoot = "_os-0";
export var sliderThumb = "_os-3";
export var sliderTrack = "_os-1";